<template>
  <div>
    <main id="error" class="errorPage" v-if="Object.keys(error).length">
      <section :style="'background-color:'+error.bgcolor">
        <header class="section-title">
          <h1>404</h1>
        </header>
         <div class="text--content" v-html="setText(error[currentLang])"></div>
      </section>
    </main>
     <ContactFooter :isLandingMounted="true" :displayLogo="true" :site="site"/>
  </div>
</template>

<script>
import {mapState} from 'vuex'
const ContactFooter = () => import( /* webpackChunkName: "ContactFooter" */ '@/snippets/ContactFooter.vue');
import loaderHandler  from '@/mixins/loaderHandler.js'
export default {
  name: 'Error',
  props: ['currentLang'],
  computed: mapState(['error', 'site']),
  components: {ContactFooter},
  mixins: [loaderHandler],
  metaInfo() {
    return {
      title: null,
    }
  },
  methods:{
    applyBackground(el, applyColor){
      if(!el){
        return
      }
      el.style.backgroundColor = applyColor ? this.error.bgcolor : '';
    },
    changeAppearance(state){
      let body = document.getElementsByTagName('body')[0], 
          headers = document.getElementsByClassName('main-header'), 
          footer = document.getElementById('main-footer');
      if(state){
        this.applyBackground(headers[0], true);
        this.applyBackground(footer, true);
        body.classList.add("error");
      }else{
        this.applyBackground(headers[0], false);
        this.applyBackground(footer, false);

        body.classList.remove("error");
      }
    },
    setText(src){
      this.$meta.title = src.title;
      return src.mainText;
    }
  },
  created() {
    let path = this.$route.name.toLowerCase()
    this.$store.dispatch('loadError', {path});
  },
  mounted(){
    //let self = this;
    this.$emit('mountedPage', {isBgLight: true});
    // setTimeout(function(){
    //   self.changeAppearance(true);
    // },500)
  },
  beforeDestroy(){
    this.emitToApp(true);
    this.changeAppearance(false);
  }
}
</script>

<style lang="scss" scoped>
  #app #error{
    color:#fff!important;
    h1, p, .text--content{
      font-family: Courier, Courier New, serif;
    }
    .section-title{
      margin-bottom:0;
      font-size: 9rem;
      text-align: center;
      line-height:initial;
      @media screen and (min-width:768px){
         font-size:20rem;
      }
      h1{
        margin:auto;
      }
    }
    section{
      padding: 7rem 3rem;
      min-height: calc(100vh - 8.5rem);
      text-align: center;
      @media screen and (min-width:768px){
        padding: 13rem 3rem;
        min-height: calc(100vh - 15rem);
      }
    }
  }
</style>